import React from 'react';

const BarChart = ({ 
    data = [], 
    labelKey = 'label', 
    valueKey = 'value',
    maxValue,
    height = 200,
    barColor = '#6366f1',
    showValues = true,
    horizontal = false,
    onClick,
    className = ''
}) => {
    if (!data.length) {
        return (
            <div className={`flex items-center justify-center h-${height} text-gray-400 ${className}`}>
                No data available
            </div>
        );
    }

    const max = maxValue || Math.max(...data.map(d => d[valueKey] || 0));

    if (horizontal) {
        return (
            <div className={`space-y-3 ${className}`}>
                {data.map((item, index) => {
                    const value = item[valueKey] || 0;
                    const percentage = max > 0 ? (value / max) * 100 : 0;
                    const color = item.color || barColor;

                    return (
                        <div 
                            key={index} 
                            className={`${onClick ? 'cursor-pointer hover:bg-gray-50 p-2 -m-2 rounded-lg transition-colors' : ''}`}
                            onClick={() => onClick?.(item)}
                        >
                            <div className="flex items-center justify-between mb-1">
                                <span className="text-sm font-medium text-gray-700 truncate max-w-[200px]">
                                    {item[labelKey]}
                                </span>
                                {showValues && (
                                    <span className="text-sm font-semibold text-gray-900 ml-2">
                                        {typeof value === 'number' && value % 1 !== 0 ? value.toFixed(1) : value}
                                        {item.suffix || ''}
                                    </span>
                                )}
                            </div>
                            <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
                                <div 
                                    className="h-full rounded-full transition-all duration-500 ease-out"
                                    style={{ 
                                        width: `${percentage}%`,
                                        backgroundColor: color
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    // Vertical bar chart
    return (
        <div className={`flex items-end justify-around gap-2 ${className}`} style={{ height }}>
            {data.map((item, index) => {
                const value = item[valueKey] || 0;
                const percentage = max > 0 ? (value / max) * 100 : 0;
                const color = item.color || barColor;

                return (
                    <div 
                        key={index}
                        className={`flex flex-col items-center flex-1 max-w-[60px] ${onClick ? 'cursor-pointer' : ''}`}
                        onClick={() => onClick?.(item)}
                    >
                        <div className="flex-1 w-full flex flex-col justify-end">
                            {showValues && (
                                <span className="text-xs font-semibold text-gray-700 text-center mb-1">
                                    {typeof value === 'number' && value % 1 !== 0 ? value.toFixed(1) : value}
                                </span>
                            )}
                            <div 
                                className="w-full rounded-t-md transition-all duration-500 ease-out hover:opacity-80"
                                style={{ 
                                    height: `${Math.max(percentage, 2)}%`,
                                    backgroundColor: color,
                                    minHeight: '4px'
                                }}
                            />
                        </div>
                        <span className="text-xs text-gray-500 mt-2 text-center truncate w-full">
                            {item[labelKey]}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default BarChart;
